import styled from 'styled-components';
import { Card, CardContent, Typography } from '@material-ui/core';
import { COLORS } from 'constants/design';

export const Container = styled.div`
  background-color: transparent;
  .subContainer {
    justify-content: space-around;
    margin-top: 25px;
  }
  .upload-document-button {
    font-weight: normal;
    font-size: 14px;
    width: 100%;
  }
  .validate-button {
    margin-right: 20px;
  }
  .reject-button {
    margin-left: 20px;
  }
  .top-card {
    justify-content: space-between;
  }
`;

export const Title2 = styled(Typography)`
  text-align: left;
  color: #5d5a5a;
  font-weight: 400;
  font-size: small;
  margin-top: 5px;
`;

export const StyledTitleTypography = styled(Typography)`
  font-size: 12px;
  color: ${COLORS.ACCORDION_GRAY};
`;

export const SahamTabsGlobal = styled.div`
  background-color: #fff;
  margin-top: 20px;
  .MuiTabs-flexContainer {
    display: flex;
    align-items: center;
    background-color: transparent;
  }
`;
export const JudgementAddDecisionStyle = styled.div`
  position: absolute;
  right: 234px;
  margin-top: -63px;
`;

export const StyledGridButton = styled.div`
  position: absolute;
  right: 250px;
  margin-top: -15px;
  height: 50px;
`;
export const StyledDecisionDropDown = styled.div`
  width: 70%;
  min-height: 43px;
  background: #fbfbfb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  padding: 2px;
  margin-top: 60px;
  .drop-down-icon {
    fill: #212121;
  }
  .drop-down-button {
    font-size: 15px;
    justify-content: space-between;
    width: 100%;
    font-weight: 600;
    color: #212121;
    text-transform: none;
    opacity: 1;
    letter-spacing: 0.02px;
  }
  .popper {
    margin-top: 5px;
    transform: translate3d(0px, 40px, 0px);
    min-width: 238px;
    z-index: 100;
    background-color: #fafafa;
    box-shadow: 0px 2px 10px #00000033;
  }
`;
export const StyledTopDiv = styled.div`
  margin-top: 40px;
`;
export const StyledCardContent = styled(CardContent)`
  padding: 0px;
  justify-content: space-between;
`;

export const StyledGrid = styled.div`
  position: absolute;
  right: 64px;
  margin-top: -40px;
  height: 50px;
`;
export const StyledCard = styled(Card)`
  padding-left: 16px;
  justify-content: space-between;
`;
export const Title = styled(Typography)`
  text-align: left;
  letter-spacing: 0;
  margin-left: 10px;
  margin-top: 20px;
  color: #2b2727;
  font-weight: 500;
  font-family: Roboto;
`;
export const StyledDiv = styled.div`
  margin-top: 40px;
  justify-content: space-between;
`;

export const StyledCheckBox = {
  marginLeft: '16px',
  fontSize: '15px',
};
export const StyledChip = {
  color: COLORS.WHITE,
  fontWeight: 700,
  backgroundColor: COLORS.BLUE_MENU_PRIMARY,
  borderWidth: 1,
  marginLeft: 10,
  marginTop: '13px',
};
